export default "__VITE_ASSET__B2WB85za__"